(function () {
  if (window.__specrVehicleChipInit) return;
  window.__specrVehicleChipInit = true;

  var SEARCH_CONTEXT_KEY = "specr_tire_search_context";
  var RESULTS_PAGE = "/pages/tire-results";

  function encodeParam(val) {
    return encodeURIComponent(String(val || ""));
  }

  function resultsUrlFromVehicle(v) {
    if (!v) return "";
    if (v.vin) return RESULTS_PAGE + "?vin=" + encodeParam(v.vin);
    if (v.id) return RESULTS_PAGE + "?vehicleId=" + encodeParam(v.id);
    if (v.year && v.make && v.model) {
      var q =
        "?year=" +
        encodeParam(v.year) +
        "&make=" +
        encodeParam(v.make) +
        "&model=" +
        encodeParam(v.model);
      if (v.trim) q += "&trim=" + encodeParam(v.trim);
      return RESULTS_PAGE + q;
    }
    return "";
  }

  function labelFromVehicle(v) {
    if (!v) return "";
    var parts = [v.year, v.make, v.model].filter(Boolean);
    if (parts.length) return parts.join(" ");
    if (v.title) return v.title;
    if (v.size) return v.size;
    return "";
  }

  function readSessionContext() {
    try {
      var raw = sessionStorage.getItem(SEARCH_CONTEXT_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function resultsUrlFromContext(ctx) {
    if (!ctx) return "";
    if (ctx.size) return RESULTS_PAGE + "?size=" + encodeParam(ctx.size);
    if (ctx.vin) return RESULTS_PAGE + "?vin=" + encodeParam(ctx.vin);
    if (ctx.vehicleId) return RESULTS_PAGE + "?vehicleId=" + encodeParam(ctx.vehicleId);
    if (ctx.year && ctx.make && ctx.model) {
      var q =
        "?year=" +
        encodeParam(ctx.year) +
        "&make=" +
        encodeParam(ctx.make) +
        "&model=" +
        encodeParam(ctx.model);
      if (ctx.trim) q += "&trim=" + encodeParam(ctx.trim);
      return RESULTS_PAGE + q;
    }
    return "";
  }

  function labelFromContext(ctx) {
    if (!ctx) return "";
    if (ctx.size) {
      var s = String(ctx.size);
      var m = s.match(/^(\d{3})-(\d{2})-(\d{2})$/);
      if (m) return m[1] + "/" + m[2] + "R" + m[3];
      return s;
    }
    var ymm = [ctx.year, ctx.make, ctx.model].filter(Boolean);
    if (ymm.length) return ymm.join(" ");
    if (ctx.vin) return "VIN …" + String(ctx.vin).slice(-4);
    return "";
  }

  function hydrateChip(root) {
    if (!root || root.getAttribute("data-specr-vehicle-chip-ready") === "true") return;

    var searchLink = root.querySelector("[data-specr-vehicle-chip-search]");
    var changeLink = root.querySelector("[data-specr-vehicle-chip-change]");
    var labelEl = root.querySelector("[data-specr-vehicle-chip-label]");
    if (!searchLink || !labelEl) return;

    var guestFinder = root.getAttribute("data-guest-finder") || "/pages/tires#vehicle";
    var garagePage = root.getAttribute("data-garage-page") || "/pages/customer-page";
    var custId = root.getAttribute("data-customer-id");
    var changeHref = custId ? garagePage : guestFinder;

    function show(label, searchHref, showChange) {
      labelEl.textContent = label;
      searchLink.href = searchHref;
      if (changeLink) {
        changeLink.href = changeHref;
        changeLink.hidden = !showChange;
      }
      root.hidden = false;
      root.setAttribute("data-specr-vehicle-chip-ready", "true");
    }

    function showEmpty() {
      show("Add your vehicle", custId ? garagePage : guestFinder, false);
    }

    if (custId) {
      var path = (window.location.pathname || "").toLowerCase();
      if (
        path.indexOf("customer-page") !== -1 ||
        path.indexOf("customer-vehicles") !== -1 ||
        path.indexOf("customer-vehicle-detail") !== -1
      ) {
        show("Your vehicles", garagePage, false);
        return;
      }
      fetch("/apps/specr/api/vehicles?logged_in_customer_id=" + encodeURIComponent(custId))
        .then(function (r) {
          return r.json();
        })
        .then(function (d) {
          var vehicles = d.vehicles || d.customerVehicles || [];
          if (!vehicles.length) {
            showEmpty();
            return;
          }
          var v = vehicles[0];
          var label = labelFromVehicle(v);
          var href = resultsUrlFromVehicle(v) || garagePage;
          show(label || "Your vehicle", href, true);
        })
        .catch(function () {
          showEmpty();
        });
      return;
    }

    var ctx = readSessionContext();
    var ctxLabel = labelFromContext(ctx);
    if (ctxLabel) {
      var ctxHref = resultsUrlFromContext(ctx) || guestFinder;
      show(ctxLabel, ctxHref, true);
      return;
    }

    showEmpty();
  }

  function initAll() {
    document.querySelectorAll("[data-specr-vehicle-chip]").forEach(function (root) {
      root.removeAttribute("data-specr-vehicle-chip-ready");
      hydrateChip(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  window.addEventListener("storage", function (e) {
    if (e.key === SEARCH_CONTEXT_KEY) initAll();
  });
})();
